import { apiSlice } from "./apiSlice";
// export const Activesizelist = createAsyncThunk('/activesizelist', async () => {
//   const response = await ApiHelperFunction({
//     urlPath: 'size/active/size',
//     method: 'GET',
//   });
//   return response;
// });
export const SizeSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    sizelist: builder.mutation({
      query: (data) => ({
        url: 'size?' + data,
        method: 'GET',
        credentials: "include",
      }),

    }),
    Create_Update_size: builder.mutation({
      query: (data) => ({
        url: 'size',
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
    Getsize: builder.mutation({
      query: (id) => ({
        url: 'size/' + id,
        method: 'GET',
        credentials: "include",
      }),
    }),

    Deletesize: builder.mutation({
      query: (id) => ({
        url: 'size',
        method: "DELETE",
        body: id,
        credentials: "include",
      }),
    }),
    getActivesize: builder.mutation({
      query: () => ({
        url: 'size/active/size',
        method: "GET",
        credentials: "include",
      }),
    }),


  }),
});

export const {
  useSizelistMutation,
  useCreate_Update_sizeMutation,
  useGetsizeMutation,
  useDeletesizeMutation,
  useGetActivesizeMutation
} = SizeSlice;

